import React from 'react'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { SubscriptionLayout } from '@pff-consumer/feature-account/components/subscription-layout/subscription-layout.web'
import { PffInsights } from '../common/pff-insights/pff-insights'

const { useBreakpoints } = checkoutHooks

export const Subscription = () => {
  const { isDesktop } = useBreakpoints()

  return (
    <>
      {!isDesktop && <PffInsights />}
      <SubscriptionLayout />
    </>
  )
}
